export default __webpack_public_path__ + "static/media/offer.bcb0e64e.png";